"use client"

import { useMatchMedia } from "~/hooks/useMatchMedia"
import type { Asset } from "~/types/asset"

import s from "./PageBackground.module.scss"

type Props = {
  desktop: Asset | null
  mobile: Asset | null
}

export const PageBackgroundVideo = ({ desktop, mobile }: Props) => {
  // null = SSR / pre-hydration: no video loaded yet (lazy load)
  // true = desktop (≥768px), false = mobile (<768px)
  const isDesktop = useMatchMedia("sm", { defaultValue: null })
  const prefersReducedMotion = useMatchMedia("(prefers-reduced-motion: reduce)")

  if (isDesktop === null || prefersReducedMotion) return null

  const asset = isDesktop ? (desktop ?? mobile) : (mobile ?? desktop)

  if (!asset) return null

  if (asset.kind === "json") {
    return (
      <iframe
        className={s.embed}
        src={`${asset.url}?background=1&dnt=1`}
        title="Background video"
        tabIndex={-1}
        aria-hidden="true"
        allow="autoplay; fullscreen"
      />
    )
  }

  if (asset.kind === "video") {
    return (
      <video
        className={s.video}
        src={asset.url}
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        aria-hidden="true"
      />
    )
  }

  return null
}
